<div
  class="toggle-container"
  [ngClass]="{ disabled: disabled }"
  [title]="disabled ? disabledTooltip : ''"
  [attr.aria-disabled]="disabled"
>
  <span [ngStyle]="{ color: textColor }">{{ itsThis }}</span>
  <div class="toggle-switch">
    <input
      [checked]="state"
      (change)="onChange($event)"
      type="checkbox"
      id="toggle"
      class="toggle-input"
    />
    <label
      for="toggle"
      class="toggle-label"
      [ngStyle]="{ borderColor: toggleBorderColor }"
    >
      <span
        class="toggle-ball"
        [ngStyle]="{ backgroundColor: toggleBallColor }"
      ></span>
    </label>
  </div>
  <span [ngStyle]="{ color: textColor }">{{ itsThat }}</span>
</div>
